import type { MyBetsState } from '../../types/myBets';

interface LocationUpdatePayload {
  pathname: string;
}

const betsChanged = (state: MyBetsState, payload: LocationUpdatePayload): MyBetsState => {
  const hasMyBetsChanged =
    (payload.pathname.includes('/my-bets/open') && state.isSettled) ||
    (payload.pathname.includes('/my-bets/settled') && !state.isSettled);

  if (hasMyBetsChanged) {
    return {
      ...state,
      isFetching: true,
      isErroneous: false
    };
  }

  return state;
};

export default betsChanged;
